import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';
import { ArrowBack } from '@mui/icons-material';

const HeaderLinks = ({ onClose, stateRef }) => {
  const { t } = useTranslation();
  const [disabledSave, setDisabledSave] = useState(true);

  const handleDisabledSaveChange = disabled => setDisabledSave(disabled);

  stateRef.current = {
    ...stateRef.current,
    onDisabledSaveChange: handleDisabledSaveChange
  };

  const handleSave = () => {
    const { onSave } = stateRef.current;
    onSave();
  };

  return (
    <>
      <IconButton fontSize='medium' color='transparent' tooltip={t('Authorization.BackToList')} onClick={onClose}>
        <ArrowBack />
      </IconButton>
      <IconButton
        type='save'
        fontSize='medium'
        color='transparent'
        tooltip={t('Authorization.SaveChanges')}
        onClick={handleSave}
        disabled={disabledSave}
      />
    </>
  );
};

HeaderLinks.propTypes = {
  onClose: PropTypes.func.isRequired,
  stateRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })])
};

export default HeaderLinks;
